import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAMLSCommonUnifiedAlerts } from '../../../redux/actions/common';
import AlertHistory from './AlertHistory';

function mapStateToProps(state) {
  const {
    unifiedAlerts = {},
    alertDetails = {},
    alertPartyIdentity = {}
  } = state.amlsCommon;
  const { data: alertHistory, error, isLoading } = unifiedAlerts;
  const { data: customerInfo } = alertDetails;
  const { data: partyKeyInfo } = alertPartyIdentity;
  const { primaryPartyKey = '' } = customerInfo || {};
  const { partyKey = '' } = partyKeyInfo || {};

  return {
    alertHistory,
    error,
    isLoading,
    customerId: primaryPartyKey || partyKey
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSCommonUnifiedAlerts
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertHistory);
